import { ErrorSummary } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { useOppvarmingFormContext } from '../../utils';
import { ErrorGroupWrapper } from '../formErrors/styledComponents';
import { hasErrors } from '../formErrors/utils';
import { ErrorLinkItem } from '../formErrors/errorLinkItem';

// Bioenergi errors consists of four categories -  the main category Bioenergi, with three subgroups: "Biokamin",
// "Bio-ovn med vannkappe" and "Biokjel".
export const BioenergiErrorSummary = () => {
  const { formState } = useOppvarmingFormContext();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.bioenergi' });

  const errors = formState.errors.bioenergi;

  const bioenergiError = errors?.value?.kaminMedVannbarenVarme?.selected;
  const biokaminErrors = errors?.value?.kamin?.value;
  const bioOvnMedVannkappeErrors = errors?.value?.kaminMedVannbarenVarme?.value;
  const biokjelErrors = errors?.value?.kjel?.value;

  if (!errors) {
    return null;
  }

  return (
    <Fragment>
      {bioenergiError && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={bioenergiError} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}

      {hasErrors(biokaminErrors) && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('biokamin.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={biokaminErrors?.installasjonsAr} />
            <ErrorLinkItem error={biokaminErrors?.vetInstallasjonsAr} />
            <ErrorLinkItem error={biokaminErrors?.termostatstyring} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
      {hasErrors(bioOvnMedVannkappeErrors) && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('bioOvnMedVannkappe.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={bioOvnMedVannkappeErrors?.varmesentral?.installasjonsAr} />
            <ErrorLinkItem error={bioOvnMedVannkappeErrors?.varmesentral?.vetInstallasjonsAr} />
            <ErrorLinkItem error={bioOvnMedVannkappeErrors?.varmesentral?.varmesentralType} />
            <ErrorLinkItem error={bioOvnMedVannkappeErrors?.varmesentral?.installertIOppvarmetRom} />
            <ErrorLinkItem error={bioOvnMedVannkappeErrors?.bruk?.romoppvarming} />
            <ErrorLinkItem error={bioOvnMedVannkappeErrors?.installasjonsAr} />
            <ErrorLinkItem error={bioOvnMedVannkappeErrors?.vetInstallasjonsAr} />
            <ErrorLinkItem error={bioOvnMedVannkappeErrors?.radiator?.selected} />
            <ErrorLinkItem error={bioOvnMedVannkappeErrors?.radiator?.value?.termostatstyring} />
            <ErrorLinkItem error={bioOvnMedVannkappeErrors?.gulvvarme?.value?.termostatstyring} />
            <ErrorLinkItem error={bioOvnMedVannkappeErrors?.serviceGjennomfortSiste2Ar} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
      {hasErrors(biokjelErrors) && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('biokjel.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={biokjelErrors?.varmesentral?.installasjonsAr} />
            <ErrorLinkItem error={biokjelErrors?.varmesentral?.vetInstallasjonsAr} />
            <ErrorLinkItem error={biokjelErrors?.varmesentral?.varmesentralType} />
            <ErrorLinkItem error={biokjelErrors?.varmesentral?.installertIOppvarmetRom} />
            <ErrorLinkItem error={biokjelErrors?.bruk?.romoppvarming} />
            <ErrorLinkItem error={biokjelErrors?.installasjonsAr} />
            <ErrorLinkItem error={biokjelErrors?.vetInstallasjonsAr} />
            <ErrorLinkItem error={biokjelErrors?.radiator?.selected} />
            <ErrorLinkItem error={biokjelErrors?.radiator?.value?.termostatstyring} />
            <ErrorLinkItem error={biokjelErrors?.gulvvarme?.value?.termostatstyring} />
            <ErrorLinkItem error={biokjelErrors?.serviceGjennomfortSiste2Ar} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
    </Fragment>
  );
};
